module.exports = __webpack_public_path__ + "static/media/digicert.d1f22b8f.gif";